class EmailSignupModal extends HTMLElement {
  constructor() {
    super();
    this.details   = this.querySelector('details');
    this.summary   = this.querySelector('summary');
    this.card      = this.querySelector('.email-signup-modal__card');
    this.overlay   = this.querySelector('.email-signup-modal__overlay');
    this.closeBtn  = this.querySelector('.email-signup-modal__close');

    if (!this.details) return;

    if (this.summary) {
      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen() ? this.close() : this.open();
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    this.details.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') this.close();
    });
  }

  isOpen() {
    return this.details && this.details.hasAttribute('open');
  }

  open() {
    if (!this.details) return;
    this.details.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    if (this.card) {
      const input = this.card.querySelector('input[type="email"]');
      if (input) setTimeout(() => input.focus(), 50);
    }
  }

  close() {
    if (!this.details) return;
    this.details.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    if (this.summary) this.summary.focus();
  }
}

customElements.define('email-signup-modal', EmailSignupModal);
